enum StudentMessagesTab {
	Answered,
	Sent,
}

export default StudentMessagesTab;
